const types = {
    SET_LIST: '[KYC] SET LIST',
}

export {
    types
}